__turbopack_context__.v({
  "content": "AccordionContent-module-scss-module__hTpGBa__content",
  "disclaimer": "AccordionContent-module-scss-module__hTpGBa__disclaimer",
  "infocar-equipment-list-item": "AccordionContent-module-scss-module__hTpGBa__infocar-equipment-list-item",
  "infocar-equipment-section": "AccordionContent-module-scss-module__hTpGBa__infocar-equipment-section",
  "infocar-feature-element": "AccordionContent-module-scss-module__hTpGBa__infocar-feature-element",
  "infocar-feature-label": "AccordionContent-module-scss-module__hTpGBa__infocar-feature-label",
  "infocar-feature-list": "AccordionContent-module-scss-module__hTpGBa__infocar-feature-list",
  "infocar-feature-list-item": "AccordionContent-module-scss-module__hTpGBa__infocar-feature-list-item",
  "infocar-feature-value": "AccordionContent-module-scss-module__hTpGBa__infocar-feature-value",
  "infocar-section": "AccordionContent-module-scss-module__hTpGBa__infocar-section",
  "infocar-section-heading": "AccordionContent-module-scss-module__hTpGBa__infocar-section-heading",
});
